import { BaseModel } from '@Core';
import { AiReviewNotes } from './AiReviewNotes';
import { ContraventionProcessingJob } from './ContraventionProcessingJob';
import {
    GetNoPCRestriction,
    OutCome,
    PotentialContraventionWithInfo,
    PotentialContraventions,
} from './PotentialContraventions';
import { VerificationAudit } from './VerificationAudit';
import { Zones } from './Zones';

export interface GroupPotentialContraventions extends BaseModel {
    ZoneId: number;
    Zone?: Zones;
    Plate: string;
    OutCome: OutCome;
    ReadDate: Date;

    Step?: number;
    LastUpdateBy?: string;

    PotentialContraventions?: PotentialContraventions[] | PotentialContraventionWithInfo[];
    NoPCRestriction?: GetNoPCRestriction;
    VerificationAudit?: VerificationAudit;

    IsExemptionPlate?: boolean;

    AiConfidence?: number;
    AiNotes?: AiReviewNotes;
    AiReviewedAt?: Date;

    ProcessingJobId?: number;
    ContraventionProcessingJob?: ContraventionProcessingJob;
}

export enum AiConfidenceLevel {
    Low = 'Low',
    Medium = 'Medium',
    High = 'High',
    PendingAI = 'Pending AI',
}
